import { GOALS } from "@/lib/discovery";

/** The opportunity map. Ranked, honest about impact, concrete about what gets built. */
export default function Results({ opportunities }) {
  return (
    <ol className="border-t border-ink" data-testid="results">
      {opportunities.map((o, i) => {
        const goal = GOALS.find((g) => g.id === o.category);
        return (
          <li key={o.id} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-6 border-b border-ink" data-testid={`opp-${o.id}`}>
            <div className="md:col-span-1 flex md:block items-baseline gap-3">
              <span className="numeral text-[40px] md:text-[52px] leading-[0.85]">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <div className="md:col-span-6">
              <p className="eyebrow">{o.problem}</p>
              <h3 className="display text-[26px] md:text-[32px] leading-[1.08] mt-2">{o.title}</h3>
              <p className="mt-3 text-[13px] text-ink/60">Helps you <span className="text-cobalt font-medium">{goal?.label.toLowerCase()}</span>.</p>
            </div>
            <div className="md:col-span-5">
              <div className="flex items-baseline justify-between gap-4">
                <span className="eyebrow">Potential impact</span>
                <span className={`text-[13px] font-semibold uppercase tracking-[0.08em] ${o.impact === "High" ? "text-ember-deep" : "text-ink"}`}>{o.impact}</span>
              </div>
              <p className="eyebrow mt-4 mb-2" style={{ color: "rgba(22,19,15,.55)" }}>AUT labs could build</p>
              <ul className="flex flex-wrap gap-2">
                {o.builds.map((b) => <li key={b} className="chip">{b}</li>)}
              </ul>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
